<div class="text-white px-6 py-3 rounded-lg shadow-lg max-w-md mx-auto mt-3 mb-4" style="background: #fff;">
    <div class="flex justify-center mb-4">
        <!-- <mat-icon [ngClass]="params_data.status=='PYMNTSCS' ? 'text-green-500 text-6xl' : 'text-red-500 text-6xl'"> {{
            params_data.status=='PYMNTSCS' ?
            'check_circle':'cancel'}}</mat-icon> -->


            <div>
                <img src="../../../../assets/images/home/success.png" *ngIf="params_data.status=='PYMNTSCS'" style="width: 80px;">
                <img src="../../../../assets/images/home/failed.png" *ngIf="params_data.status!='PYMNTSCS'" style="width: 80px;">
            </div>

    </div>
    <h2 class="text-center text-xl font-semibold" [ngStyle]="{'color': params_data.status=='PYMNTSCS' ? '#544fb2' : '#d36b59' }" style="font-size: 14px !important;">{{paymentsDetails?.trnsn_sts_nm}}</h2>
    <p class="text-center text-sm mt-2" style="color: #010101;">
        It takes 1 business day for payments to reflect in your loan account.
    </p>




    <!-- Payment Details -->
    <div class="bg-white text-black rounded-lg mt-2">
        <h3 class="font-semibold text-lg mb-2" style="font-size: 13px !important;
        font-weight: 600 !important;
        color: #1b59a7;">Payment Details</h3>

        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Loan Account Number</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.ln_id}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Amount Paid</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.amount |
                    currency:"INR"}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Transaction Reference Number</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.trnsn_rfrnc_nu}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Transaction Status</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.trnsn_sts_nm}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Beneficiary Name</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.bnfcy_nm}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Beneficiary Contact</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.contact}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">EMI Month</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.emi_mnth}}</h1>
            </div>
        </div>
        <div class="flex my-1 w-full prfDtl">
            <div class="flex flex-col w-2/4">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">Transaction Date/Time</h1>
            </div>
            <div class="flex flex-col w-7">
                <h1 class="justify-start"  style="font-size: 13px;text-transform: capitalize;">:</h1>
            </div>
            <div class="flex flex-col w-2/4">
                <h1 class="justify-end"  style="font-size: 13px !important;text-transform: capitalize;font-weight: 600;">{{paymentsDetails?.paymt_ts |
                    date:'dd-MM-yyyy hh:mm'}}</h1>
            </div>
        </div>
    </div>

    <!-- Offers Section -->
    <div class="mt-3" style="justify-content: center;display: flex;">
        <button mat-stroked-button color="primary" class="ml-2" (click)="onBack()"
            style=" font-size: 12px;
    background: #E8EAF6;        ">Back</button>

    </div>
</div>